const playbackStops = new Map();
let activeOwner = null;

export function registerSpeechPlayback(owner, stopPlayback) {
  if (!owner || typeof stopPlayback !== 'function') {
    return () => {};
  }

  playbackStops.set(owner, stopPlayback);
  return () => {
    playbackStops.delete(owner);
    if (activeOwner === owner) activeOwner = null;
  };
}

export function claimSpeechPlayback(owner) {
  playbackStops.forEach((stopPlayback, registeredOwner) => {
    if (registeredOwner !== owner) stopPlayback();
  });
  activeOwner = owner;
}

export function releaseSpeechPlayback(owner) {
  if (activeOwner === owner) activeOwner = null;
}

export function resetSpeechPlaybackCoordinator() {
  playbackStops.clear();
  activeOwner = null;
}
